import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

/**
 * Custom hook to determine if the current user is a kid profile
 * - Checks `isKid` status from the Redux store
 * - Overrides with `true` if the current location path is `/kids`
 * @returns {boolean} - `true` if the user is a kid profile, otherwise `false`
 */
export const useIsKid = () => {
  let isKid = useSelector(state => state.session.decodedJwt?.isKid) || false
  const location = useLocation()
  if (location?.pathname === '/kids') {
    isKid = true
  }

  return isKid
}
